import type { CurrencyDisplay } from './types';

export function formatPrice(priceILS: number, currency: CurrencyDisplay): string {
  const converted = priceILS * currency.exchange_rate;
  if (currency.compact) {
    const whole = Math.abs(converted - Math.round(converted)) < 0.005;
    const text = converted.toLocaleString('en-US', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2,
    });
    return `${text} ${currency.symbol}`;
  }
  return `${converted.toFixed(2)} ${currency.symbol}`;
}
